import { Asset } from '@/shared/api/protocol-ts/model/dto_asset_pb';

import { TOOTH_PAGE_GROUPS, TOOTH_PAGE_PATHOLOGY_GROUPS } from '../config';

export const getMedicalImageGroupName = (medicalImage: Asset): string => {
  switch (medicalImage.Kind.case) {
    case 'GeneratedReport': {
      const generatedReport = medicalImage.Kind.value;

      switch (generatedReport.Content.case) {
        case 'CBCTGPToothSlice': {
          const groupCode = generatedReport.Content.value.Orientation;
          const group = TOOTH_PAGE_GROUPS.find(
            (group) => group.groupCode === groupCode,
          );

          return group?.groupName ?? '';
        }
        case 'CBCTToothPathologySlice': {
          const groupCode = generatedReport.Content.value.Pathology;
          const group = TOOTH_PAGE_PATHOLOGY_GROUPS.find(
            (group) => group.groupCode === groupCode,
          );

          return group?.groupName ?? '';
        }
        default:
          return '';
      }
    }
    case 'Report': {
      const report = medicalImage.Kind.value;

      switch (report.Content.case) {
        case 'UserUploadedToothSlice':
          return 'UserUpload';
        case 'UserUploadedMPRPlane':
          return 'SavedMPR';
        default:
          return '';
      }
    }
    default:
      return '';
  }
};
